import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';
import {exportHtmlTableToExcel, exportJsonToExcel} from './utils';

export class ExportToExcelButton extends Component {
  render() {
    return (
      <Button secondary type='button' size='small' className='add-btns-pading' compact
        onClick={(e) => exportJsonToExcel(e, this.props)}>
        <img src={`${process.env.PUBLIC_URL}/icons/excel.svg`} alt='excel icon' width={25} />
      </Button>
    );
  }
}

export class ExportToExcelIconButton extends Component {
  handleExportHtmlToExcelClick = (e, props) => {
    e.preventDefault();
    const {tableId, sheetName, fileName} = props;
    exportHtmlTableToExcel(tableId, sheetName, fileName);
  };

  render() {
    return (
      <Button secondary type='button' size='small' className='add-btns-pading' compact
        style={{'padding': '0.65em', 'paddingTop': '0.55em'}}
        onClick={(e) => this.handleExportHtmlToExcelClick(e, this.props)}>
        <img src={`${process.env.PUBLIC_URL}/icons/excel.svg`} alt='excel icon' width={25} />
      </Button>
    );
  }
}
